import { render, staticRenderFns } from "./LyndaDataScope.vue?vue&type=template&id=35280700"
import script from "./LyndaDataScope.vue?vue&type=script&lang=js"
export * from "./LyndaDataScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports